import ApiService from "../api.services";

const OrderServicesDetailsService = {
  findbyOs: async function (os_id) {
    try {
      const response = await ApiService.get(
        `/api/orderservice-history/find/by-orderservice/${os_id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  findByTag: async function (tag) {
    try {
      const response = await ApiService.get(
        `/api/orderservice-history/find/by-tag/${tag}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export { OrderServicesDetailsService };
